module.exports = __webpack_public_path__ + "img/bigscoots.ee00c783.jpg";